import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_inbox",
  "use": "svg_inbox-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_inbox\"><path d=\"M.75 9v6c0 1.125 1.125 2.25 2.25 2.25h12c1.125 0 2.25-1.125 2.25-2.25V9M.75 9h4.125S6 11.625 9 11.625 13.125 9 13.125 9h4.125M.75 9l3-8.25h10.5l3 8.25M.75 9v2.625M17.25 9v2.625\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol